<template>
    <div>
        <div class="row row-eq-height justify-content-center">
            <points-widget color="box--dark-blue"></points-widget>
            <prizes-widget color="box--blue"></prizes-widget>
            <invoices-widget color="box--green"></invoices-widget>
        </div>

        <div class="row row-eq-height justify-content-center">
            <certyficate-widget color="box--dark-blue"></certyficate-widget>
            <!-- <tools-widget color="box--dark-blue" v-if="user.user_type_id!=3 || (user.user_type_id==3 && user.is_certyficated)"></tools-widget> -->
            <news-widget color="box--blue"></news-widget>
            <training-widget color="box--green"></training-widget>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MainBoxSetWidget',
        data () {
            return {

            }
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/home/boxSets/MainBoxSetWidget.vue